import React from 'react';
import { ArrowLeft } from 'lucide-react';
import { useTranslations } from '../translations/translations';
import Header from '../components/Header';
import FooterMinimal from '../components/FooterMinimal';
import { useLocalizedNavigate } from '../contexts/LanguageContext';

const ConfidentialitePage = () => {
  const navigate = useLocalizedNavigate();
  const t = useTranslations();

  const scrollToContact = () => {
    navigate('/');
    setTimeout(() => {
      document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' });
    }, 100);
  };

  return (
    <div style={{ background: '#000', minHeight: '100vh', color: '#fff' }}>
      <Header onScrollToContact={scrollToContact} />
      
      <main style={{ paddingTop: '140px', paddingBottom: '6rem' }}>
        <div className="container-custom" style={{ maxWidth: '900px' }}>
          <button
            onClick={() => navigate('/')}
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '0.5rem',
              background: 'transparent',
              border: 'none',
              color: '#a3a3a3',
              fontSize: '0.9rem',
              fontWeight: 300,
              cursor: 'pointer',
              marginBottom: '3rem',
              transition: 'color 0.3s ease'
            }}
            onMouseEnter={(e) => e.target.style.color = '#ffffff'}
            onMouseLeave={(e) => e.target.style.color = '#a3a3a3'}
          >
            <ArrowLeft className="w-4 h-4" />
            {t.confidentialityPage.backHome}
          </button>

          <h1 style={{
            fontSize: 'clamp(1.9rem, 8vw, 3rem)',
            fontWeight: 200,
            letterSpacing: '-0.02em',
            marginBottom: '1.5rem'
          }}>
            {t.confidentialityPage.title}
          </h1>

          <p style={{
            fontSize: '1.1rem',
            color: '#a3a3a3',
            fontWeight: 300,
            lineHeight: 1.8,
            marginBottom: '4rem'
          }}>
            {t.confidentialityPage.subtitle}
          </p>

          <div style={{ display: 'flex', flexDirection: 'column', gap: '3rem' }}>
            {t.confidentialityPage.sections.map((section, index) => (
              <section key={index}>
                <h2 style={{
                  fontSize: '1.5rem',
                  fontWeight: 300,
                  marginBottom: '1rem',
                  letterSpacing: '-0.01em'
                }}>
                  {section.title}
                </h2>
                <div style={{
                  fontSize: '1rem',
                  color: '#a3a3a3',
                  lineHeight: 1.8,
                  fontWeight: 300
                }}>
                  {section.content.map((paragraph, pIndex) => (
                    <p key={pIndex} style={{ marginBottom: '1rem' }}>
                      {paragraph}
                    </p>
                  ))}
                </div>
              </section>
            ))}
          </div>

          <div style={{
            marginTop: '4rem',
            padding: '2rem',
            border: '1px solid #262626',
            borderRadius: '8px',
            background: 'rgba(10, 10, 10, 0.8)'
          }}>
            <p style={{
              fontSize: '0.95rem',
              color: '#a3a3a3',
              lineHeight: 1.6,
              fontWeight: 300,
              textAlign: 'center'
            }}>
              {t.confidentialityPage.contact}
            </p>
          </div>
        </div>
      </main>

      <FooterMinimal />
    </div>
  );
};

export default ConfidentialitePage;
